import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './style.scss';

const ModalInformChangeRole = ({...props}) => {
  return <Modal show={props.show} className='modal-inform'>
    <div className='modal-inform__text-content'>{props.content}</div>
    {
      !props.isHiddenModalInformButton && <button className='btn btn-primary btn-siteone btn-ok' onClick={props.onClose}>OK</button>
    }

  </Modal>;
};

ModalInformChangeRole.propTypes = {
  show: PropTypes.bool,
  isHiddenModalInformButton: PropTypes.bool,
  content: PropTypes.any,
  onClose: PropTypes.func
};

export default ModalInformChangeRole;



// WEBPACK FOOTER //
// ./src/components/modal-inform/index.js